// Single dispatch point for logbook PDF generation.
import { ENABLE_ACADEMY_147_PDF } from "@/config/featureFlags";
import { generateStandardLogbookPdf } from "./standardLogbookPdf";
import { generateAcademy147LogbookPdf } from "./academy147LogbookPdf";

export function generateLogbookPdf(context) {
    const builder = ENABLE_ACADEMY_147_PDF
        ? generateAcademy147LogbookPdf
        : generateStandardLogbookPdf;
    return builder(context);
}
